module.exports = __webpack_public_path__ + "media/img/Landing_Page/tutor-02-90feb8b6ccdaf37026f45bf425ab32ef.jpg";